// src/theme/themeEngine.js
import React from 'react';
import { themeMap } from './themeMap';

export const transformClassName = (classString) => {
  if (!classString || typeof classString !== 'string') return classString;
  return classString
    .split(/\s+/)
    .map((cls) => themeMap[cls] || cls)
    .join(' ');
};

let isEngineInitialized = false;

export const initThemeEngine = () => {
  if (isEngineInitialized) return;
  isEngineInitialized = true;

  // 1. Patch classic createElement
  const originalCreateElement = React.createElement;
  React.createElement = function () {
    const args = Array.from(arguments);
    const props = args[1];
    if (props && props.className) {
      props.className = transformClassName(props.className);
    }
    return originalCreateElement.apply(React, args);
  };

  // 2. Safe arguments forwarder for JSX runtimes
  const patchJsx = (originalFn) => {
    return function () {
      const args = Array.from(arguments);
      const props = args[1];
      if (props && props.className) {
        props.className = transformClassName(props.className);
      }
      return originalFn.apply(null, args); // Forwards ALL arguments safely
    };
  };

  // 3. Patch production runtime
  try {
    const jsxRuntime = require('react/jsx-runtime');
    if (jsxRuntime.jsx) jsxRuntime.jsx = patchJsx(jsxRuntime.jsx);
    if (jsxRuntime.jsxs) jsxRuntime.jsxs = patchJsx(jsxRuntime.jsxs);
  } catch (e) {}

  // 4. Patch development runtime (Fixes deep compilation issues)
  try {
    const jsxDevRuntime = require('react/jsx-dev-runtime');
    if (jsxDevRuntime.jsxDEV) jsxDevRuntime.jsxDEV = patchJsx(jsxDevRuntime.jsxDEV);
  } catch (e) {}
};